var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.dialog},[_c('h2',{class:_vm.$style['dialog-right']},[_c('span',[_vm._v("【"+_vm._s(_vm.title)+"】")])])]),_c('main',{class:_vm.$style.content},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }